import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../_services/_iam/authentication-service.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule],
  selector: 'app-testing',
  templateUrl: './testing.component.html',
})
export class TestingComponent implements OnInit {
  jsonResponse: any = {};

  constructor(private authService: AuthenticationService) {}

  ngOnInit() {
    this.authService
      .verifyAccountTokenVerification(
        '2dbabdda8aa9f7aba8a80b75c5bd63e1',
        'testMfre@gmail.com'
      )
      .subscribe((response) => {
        this.jsonResponse = response;
      });
  }
}
